var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('dt', {
    class: _vm._f("twMerge")(['text-sm font-semibold text-gray-900', _vm.className])
  }, [_vm._t("default")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }